"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var CTALink = _propTypes["default"].shape({
  URL: _propTypes["default"].string,
  label: _propTypes["default"].string,
  openNewTab: _propTypes["default"].bool
});
var DealerAddress = _propTypes["default"].shape({
  addressLine1: _propTypes["default"].string,
  addressLine2: _propTypes["default"].string,
  addressLine3: _propTypes["default"].string,
  latitude: _propTypes["default"].number,
  longitude: _propTypes["default"].number,
  city: _propTypes["default"].string
});
var DealerDepartment = _propTypes["default"].shape({
  name: _propTypes["default"].string,
  workingHours: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    dayOfTheWeek: _propTypes["default"].string,
    openTime: _propTypes["default"].string,
    closeTime: _propTypes["default"].string
  }))
});
var AddressOrder = _propTypes["default"].arrayOf(_propTypes["default"].string);
var Dealer = _propTypes["default"].shape({
  id: _propTypes["default"].number,
  name: _propTypes["default"].string,
  dealershipMarketId: _propTypes["default"].string,
  url: _propTypes["default"].string,
  email: _propTypes["default"].string,
  rating: _propTypes["default"].number,
  phone: _propTypes["default"].shape({
    phoneType: _propTypes["default"].string,
    countryCode: _propTypes["default"].string,
    areaCode: _propTypes["default"].string,
    phoneNumber: _propTypes["default"].string,
    extensionNumber: _propTypes["default"].string
  }),
  address: DealerAddress.isRequired,
  distance: _propTypes["default"].number,
  pinLabel: _propTypes["default"].string,
  logo: _propTypes["default"].string,
  dealerDepartments: _propTypes["default"].arrayOf(DealerDepartment)
});
var Language = _propTypes["default"].shape({
  language: _propTypes["default"].string,
  direction: _propTypes["default"].string
});
var Location = _propTypes["default"].shape({
  lat: _propTypes["default"].number,
  lng: _propTypes["default"].number
});
var MetricSystem = _propTypes["default"].oneOf(['imperial', 'metric']);
var PageData = _propTypes["default"].shape({
  title: _propTypes["default"].string,
  locationCtaLabel: _propTypes["default"].string,
  salesSearchFilterLabel: _propTypes["default"].string,
  serviceSearchFilterLabel: _propTypes["default"].string,
  allDealershipsSearchFilterLabel: _propTypes["default"].string,
  errorNoDealershipsLabel: _propTypes["default"].string,
  errorNoGeolocationLabel: _propTypes["default"].string,
  searchHelpText: _propTypes["default"].string,
  searchResultsFoundLabel: _propTypes["default"].string,
  saleOpeningHoursLabel: _propTypes["default"].string,
  serviceOpeningHoursLabel: _propTypes["default"].string,
  testDriveCTA: CTALink,
  carServiceCTA: CTALink,
  contactLabel: _propTypes["default"].string,
  measurementSystem: _propTypes["default"].string,
  showRating: _propTypes["default"].bool,
  noDealershipFoundMessage: _propTypes["default"].string,
  noGeolocationMessage: _propTypes["default"].string
});
var Theme = _propTypes["default"].objectOf(_propTypes["default"].string);
var Filters = _propTypes["default"].arrayOf(_propTypes["default"].shape({
  label: _propTypes["default"].string,
  value: _propTypes["default"].string
}));
var Types = {
  CTALink: CTALink,
  Dealer: Dealer,
  DealerAddress: DealerAddress,
  DealerDepartment: DealerDepartment,
  AddressOrder: AddressOrder,
  Language: Language,
  Location: Location,
  MetricSystem: MetricSystem,
  PageData: PageData,
  Theme: Theme,
  Filters: Filters
};
var _default = Types;
exports["default"] = _default;